<template>
  <div class="content">
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('offlineFilters.pageAll.title') }}</h2>
      <p class="text-center">
        {{ $t('offlineFilters.pageAll.description') }}
      </p>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">{{ $t('offlineFilters.pageAll.tableTitle') }}</h4>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div class="row">
                <div class="col-6">
                  <base-input>
                    <el-input
                      type="search"
                      class="mb-3 search-input"
                      prefix-icon="el-icon-search"
                      :placeholder="$t('generic.searchInTablePlaceholder')"
                      v-model="searchQuery"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </base-input>
                </div>
              </div>
            </div>

            <el-table v-loading="loading" :data="queriedData" show-header :empty-text="$t('generic.noData')">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <offline-filter-details :details="props.row"/>
                </template>
              </el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :prop="column.prop"
                :label="$t(column.label)"
                :formatter="column.formatter">
              </el-table-column>
              <el-table-column align="right" :min-width="50">
                <div slot-scope="props">
                  <router-link
                    :to="{name: 'offlineFilter', params: {id: props.row.id}}">
                    <i class="tim-icons icon-double-right"></i>
                  </router-link>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                {{ $t('generic.tablePaginationSummary', {from: from + 1, to: to, total: total}) }}
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import {Option, Select, Table, TableColumn, Tooltip} from 'element-ui';
import {BaseAlert, BaseButton, BasePagination} from 'src/components';
import Fuse from 'fuse.js';
import OfflineFilterDetails from 'src/components/OfflineFilter/OfflineFilterDetails';
import {mapActions, mapState} from "vuex";

export default {
  name: 'OfflineFiltersPage',
  components: {
    BasePagination,
    BaseAlert,
    BaseButton,
    Tooltip,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    OfflineFilterDetails,
  },
  props: {},
  computed: {
    ...mapState({
      data: state => state.offline_filters.data,
      loading: state => state.offline_filters.loading,
    }),
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['fare_group_id'],
      tableColumns: [
        {
          prop: 'created_at',
          label: 'generic.created',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time(cellValue)
          },
          width: 120,
        }, {
          prop: 'updated_at',
          label: 'generic.updated',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time(cellValue)
          },
          width: 120,
        },
        {
          prop: 'fare_group_id',
          label: 'offlineFilters.details.fare_group_id',
          width: 60,
        },
        {
          prop: 'priority',
          label: 'offlineFilters.details.priority',
          width: 30,
        },
        {
          prop: 'id',
          label: 'generic.id',
          width: 160,
        },

        {
          prop: 'filter_kind',
          label: 'offlineFilters.details.filter_kind',
          width: 60,
        },
        {
          prop: 'not_after',
          label: 'offlineFilters.details.not_after',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time(cellValue)
          },
          width: 60,
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      showEdit: false,
      editPaymentResult: {
        data: {}
      },
    };
  },
  methods: {
    ...mapActions(['LoadOfflineFilters']),
  },
  mounted() {
    this.LoadOfflineFilters();
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    "data"(data) {
      this.tableData = data
      // Fuse search initialization.
      this.fuseSearch = new Fuse(this.tableData, {
        keys: this.propsToSearch,
        threshold: 0.3
      });
    }
  }
};
</script>
<style>
.pagination-select,
.search-input {
  width: 200px;
}
</style>
